import Gateway from '@/components/nodes/parallelGateway/parallelGateway';
import idConfigSettings from '@/components/inspectors/idConfigSettings';
import rules from '@/mixins/ilios_functions.js'

window.ProcessMaker.EventBus.$on('modeler-init', ({ registerNode }) => {
  /* Add a custom node example */

  const implementation = 'processmaker-modeler-mono-gateway';
  const nodeId = 'processmaker-modeler-mono-gateway';

  const component = {
    extends: Gateway,
    watch: {
      'node.definition.name'(name) {
        switch (name) {
          default:
            this.$delete(this.markers.topRight, 'vocabulary');
            this.$delete(this.markers.topRight, 'clock');
        }
      },
    },
  };

  const nodeType = {
    id: nodeId,
    component,
    bpmnType: 'bpmn:ParallelGateway',
    control: true,
    category: 'Other',
    icon: require('@/assets/toolpanel/mono-gateway.svg'),
    label: 'Mono Gateway',
    rank: 55,
    definition(moddle) {
      return moddle.create('bpmn:ParallelGateway', {
        name: 'Mono Gateway',
        implementation,
        config: JSON.stringify({}),
        backId: null,
      });
    },
    diagram(moddle) {
      return moddle.create('bpmndi:BPMNShape', {
        bounds: moddle.create('dc:Bounds', {
          height: 36,
          width: 36,
        }),
      });
    },
    inspectorConfig: [
      {
        name: 'Send Tweet',
        items: [
          {
            component: 'FormText',
            config: {
              label: 'Send Tweet',
              fontSize: '2em',
            },
          },
          {
            component: 'FormInput',
            config: idConfigSettings,
          },
          {
            component: 'FormInput',
            config: {
              label: 'Name',
              helper: 'Name',
              name: 'name',
            },
          },
        ],
      },
    ],
    entryRules(sequenceFlow){
      let result = []
      let findError
      result.push(rules.oneEntryConector(sequenceFlow))
      result.push(rules.entryIsMultGateway(sequenceFlow))
      result.push(rules.monoGatewayIsConnected(sequenceFlow))
      findError = result.find(el => el.result === false)
      if (findError){
        return findError
      } else {
        return {result: true}
      }
    },
    exitRules(genericFlow){
      let result = []
      let findError
      result.push(rules.oneExitConector(genericFlow))
      findError = result.find(el => el.result === false)
      if (findError){
        return findError
      } else {
        return {result: true}
      }
    },
  };

  registerNode(nodeType, definition => {
    if (definition.get('implementation') === implementation) {
      return nodeId;
    }
  });
});
